export enum Status {
    Success = 0,
    Fail = 1,
    UnAuthorized=3
}

export enum OperationResponseStatus {
    Success = "Success",
    Fail = "Fail",
    UnAuthorized = "UnAuthorized"
}